import { gql } from "@apollo/client";

export const REJECT_OPT_IN = gql`
  mutation RejectInitiativeOptin($optinId: String!, $organizationId: String!) {
    rejectInitiativeOptin(optinId: $optinId, organizationId: $organizationId) {
      id
      initiativeId
      organizationId
      status
    }
  }
`;
